/* eslint-disable prefer-template */
import Countryshow from "@/components/Countryshow";
import GetCoins from "@/components/GetCoins";
import HomeGameContainer from "@/components/HomeGameContainer";
import HomeGameTabNav from "@/components/HomeGameTabNav";
import HomeHeader from "@/components/HomeHeader";
import HomeInviteWheelFloatBall from "@/components/HomeInviteWheelFloatBall";
import HomeTabNav2 from "@/components/HomeTabNav2";
import MyNavLink from "@/components/MyNavLink";
import Slides from "@/components/Slides";
import { LocalConfig, NumericalConfig } from "@/config";
import { LocationInfo } from "@/data/LocationInfo";
import { PersistContext } from "@/data/PersistProvider";
import { RootStateContext } from "@/data/RootStateProvider";
import { LanguageContext } from "@/data/LanguageProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { GetGameUrl } from "@/data/urls";
import { SendEvent } from "@/utils/Analytics";
import { FromInstalled } from "@/utils/BroswerHelper";
import { SendCMD } from "@/utils/HTTPRequest";
import { SinNumberGenerator } from "@/utils/JSTool";
import { ChannelRemind } from "@/utils/UrlHelper";
import React, { useEffect, useRef, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Dialog, NoticeBar, Popup, Swiper, Toast } from "react-vant";
import style from "./style.less";
import DownloadFloatBall from "@/components/DownloadFloatBall";
const HomeTabList = [
  { name: "Home", link: "#" },
  { name: "League", link: "#" },
  { name: "Virtual", link: "#" },
  { name: "Freebet", link: "#" },
  { name: "App", link: "#" },
];

const BannerAds = {
  // wreath: { name: "invite", image: require("@/assets/images/home/index_banner_wreath.png").default, link: "/wreath" },
  // harvest: { name: "invite", image: require("@/assets/images/home/index_banner_harvest.png").default, link: "/harvest" },
  activity_deposit: { name: "activity_deposit", image: LocalConfig.indexBannerActivityImg, link: "/deposit" },
  first_deposit: { name: "first_deposit", image: LocalConfig.indexBannerDepositImg, link: "/deposit" },
  free_cash: { name: "free_cash", image: LocalConfig.indexBannerFreeCashImg, link: "/FreeCash" },
  luck_draw: { name: "luck_draw", image: LocalConfig.indexBannerDrawImg, link: "/luckyDraw" },
  invite_wheel: {
    name: "invite_wheel",
    image: LocalConfig.indexBannerLuckyWheelImg,
    link: "/inviteWheel",
  },
  invite: { name: "invite", image: LocalConfig.indexBannerinviteImg, link: "/invite" },
  install: { name: "install", image: LocalConfig.indexBannerInstallImg, link: "/download" },
  every_deposit: { name: "every_deposit", image: LocalConfig.indexBannerDeposit2Img, link: "/deposit" },
  withdraw: { name: "withdraw", image: LocalConfig.indexBannerWithdrawalImg, link: "/withdraw" },
};

const NowTimestamp = Date.now();

const OnlineNumberGenerator = (seed) => {
  return (SinNumberGenerator(((NowTimestamp / 1000) % 1000) / 500 / Math.PI, seed / 10) * 700 + 200).toFixed(0);
};

const JackpotNumberGenerator = (seed, from, to) => {
  return (SinNumberGenerator(((NowTimestamp / 1000) % 1000) / 500 / Math.PI, seed) * (to - from) + from).toLocaleString(
    "en-US",
    { maximumFractionDigits: 0 }
  );
};

const game2Url = GetGameUrl(2);
const game3Url = GetGameUrl(3);
const game5Url = GetGameUrl(5);

const games = {
  118: {
    id: 118,
    name: "Cooking Party",
    online: OnlineNumberGenerator(118),
    img: require("@/assets/images/games/118_cooking_party.jpg").default,
    url: game3Url + "?game_id=118",
  },
  119: {
    id: 119,
    name: "Fruit Mary",
    online: OnlineNumberGenerator(119),
    img: require("@/assets/images/games/119_fruit_slots.jpg").default,
    url: game3Url + "?game_id=119",
  },
  201: {
    id: 201,
    name: "Fortune Spin",
    online: OnlineNumberGenerator(201),
    img: require("@/assets/images/games/201_frtune_spin.jpg").default,
    url: game3Url + "?game_id=201",
  },
  202: {
    id: 202,
    name: "Super Wheel",
    online: OnlineNumberGenerator(202),
    img: require("@/assets/images/games/202_super_wheel.jpg").default,
    url: game3Url + "?game_id=202",
  },
  124: {
    id: 124,
    name: "Prairie Lion",
    online: OnlineNumberGenerator(124),
    img: require("@/assets/images/games/124_lion.jpg").default,
    url: game3Url + "?game_id=124",
  },
  203: {
    id: 203,
    name: "Crazy Roulette",
    online: OnlineNumberGenerator(203),
    img: require("@/assets/images/games/203_crazy_roulette.jpg").default,
    url: game3Url + "?game_id=203",
    hide_demo: true,
  },
  204: {
    id: 204,
    name: "Hot777 Prairie",
    online: OnlineNumberGenerator(204),
    jackpot: JackpotNumberGenerator(421, 1000000, 10000000),
    img: require("@/assets/images/games/204_hot777.jpg").default,
    url: game3Url + "?game_id=204",
  },
  205: {
    id: 205,
    name: "Big Wheel",
    online: OnlineNumberGenerator(205),
    jackpot: JackpotNumberGenerator(126, 1000000, 10000000),
    img: require("@/assets/images/games/205_spin_big.jpg").default,
    url: game3Url + "?game_id=205",
  },
  206: {
    id: 206,
    name: "Fortune Dice",
    online: OnlineNumberGenerator(206),
    img: require("@/assets/images/games/206_dice.jpg").default,
    url: game5Url + "/dice",
    hide_demo: true,
  },
  207: {
    id: 207,
    name: "Football 777",
    online: OnlineNumberGenerator(207),
    jackpot: JackpotNumberGenerator(322, 1000000, 10000000),
    img: require("@/assets/images/games/209_football777.jpg").default,
    url: game3Url + "?game_id=207",
  },
  208: {
    id: 208,
    name: "Football Honor",
    online: OnlineNumberGenerator(208),
    jackpot: JackpotNumberGenerator(142, 10000, 50000),
    img: require("@/assets/images/games/208_football.jpg").default,
    url: game3Url + "?game_id=208",
  },
  209: {
    id: 209,
    name: "Champion Team",
    online: OnlineNumberGenerator(209),
    img: require("@/assets/images/games/210_championteam.jpg").default,
    url: game3Url + "?game_id=209",
  },
  210: {
    id: 210,
    name: "Rich Or Crash",
    online: OnlineNumberGenerator(210),
    img: require("@/assets/images/games/211_rich_or_crash.jpg").default,
    url: game5Url + "/crash",
    hide_demo: true,
  },
  211: {
    id: 211,
    name: "Football Trip 10000X",
    online: OnlineNumberGenerator(211),
    img: require("@/assets/images/games/207_10000x.jpg").default,
    url: game5Url + "/crash_football",
    hide_demo: true,
  },
  14: {
    id: 14,
    name: "Blackjack",
    online: OnlineNumberGenerator(14),
    img: require("@/assets/images/games/14_black_jack.jpg").default,
    url: game3Url + "?game_id=14",
  },
  212: {
    id: 212,
    name: "Penalty Taker",
    online: OnlineNumberGenerator(212),
    img: require("@/assets/images/games/212_penalty_taker.jpg").default,
    url: game3Url + "?game_id=212",
  },
  213: {
    id: 213,
    name: "SPIN UP",
    online: OnlineNumberGenerator(213),
    img: require("@/assets/images/games/213_spin_up.jpg").default,
    url: game3Url + "?game_id=213",
  },
  214: {
    id: 214,
    name: "One card fight",
    online: OnlineNumberGenerator(214),
    img: require("@/assets/images/games/214_one_card_fight.jpg").default,
    url: game3Url + "?game_id=214",
  },
  215: {
    id: 215,
    name: "Destiny Wheel",
    online: OnlineNumberGenerator(215),
    img: require("@/assets/images/games/215_destiny_wheel.jpg").default,
    url: game3Url + "?game_id=215",
  },
  216: {
    id: 216,
    name: "Crazy Disco",
    online: OnlineNumberGenerator(216),
    img: require("@/assets/images/games/216_crazy_disco.jpg").default,
    url: game3Url + "?game_id=216",
  },
  217: {
    id: 217,
    name: "Slots Crazy",
    online: OnlineNumberGenerator(217),
    jackpot: JackpotNumberGenerator(142, 10000, 50000),
    img: require("@/assets/images/games/217_slots_crazy.jpg").default,
    url: game3Url + "?game_id=217",
  },
  218: {
    id: 218,
    name: "Fishing Clash",
    online: OnlineNumberGenerator(218),
    img: require("@/assets/images/games/218_fishing_clash.jpg").default,
    url: game3Url + "?game_id=218",
  },
  219: {
    id: 219,
    name: "Secret Garden",
    online: OnlineNumberGenerator(219),
    img: require("@/assets/images/games/219_secret_garden.jpg").default,
    url: game3Url + "?game_id=219",
  },
  220: {
    id: 220,
    name: "Jackpot X10000",
    img: require("@/assets/images/games/220_jackpot_x10000.jpg").default,
    url: game3Url + "?game_id=220",
    online: OnlineNumberGenerator(220),
  },
  221: {
    id: 221,
    name: "VOLCANIC WEALTH",
    img: require("@/assets/images/games/221_volcanic_wealth.jpg").default,
    url: game3Url + "?game_id=221",
    online: OnlineNumberGenerator(221),
  },
  222: {
    id: 222,
    name: "LUCKY MINES",
    img: require("@/assets/images/games/222_lucky_mines.jpg").default,
    url: game3Url + "?game_id=222",
    online: OnlineNumberGenerator(222),
  },
  223: {
    id: 223,
    name: "Free Spin",
    img: require("@/assets/images/games/223_free_spin.jpg").default,
    url: game3Url + "?game_id=223",
    online: OnlineNumberGenerator(223),
  },
  224: {
    id: 224,
    name: "Lucky Dice",
    img: require("@/assets/images/games/224_lucky-dice_1.jpg").default,
    url: game3Url + "?game_id=224",
    online: OnlineNumberGenerator(224),
  },
  225: {
    id: 225,
    name: "Scratch Cards",
    img: require("@/assets/images/games/225_scratch-cards.jpg").default,
    url: game3Url + "?game_id=225",
    online: OnlineNumberGenerator(225),
  },
  227: {
    id: 227,
    name: "Red-Black Clash",
    img: require("@/assets/images/games/227_red-black-clash_luka.jpg").default,
    url: game3Url + "?game_id=227",
    online: OnlineNumberGenerator(227),
    hide_demo: true,
  },
  228: {
    id: 228,
    name: "Dragon VS Tiger",
    img: require("@/assets/images/games/228_dragon_vs_tiger_luka.jpg").default,
    url: game3Url + "?game_id=228",
    online: OnlineNumberGenerator(228),
    hide_demo: true,
  },
  229: {
    id: 229,
    name: "Best Crash",
    img: require("@/assets/images/games/229_best_crash_luka.jpg").default,
    url: game3Url + "?game_id=229",
    online: OnlineNumberGenerator(229),
    hide_demo: true,
  },
  230: {
    id: 230,
    name: "Zombie Town",
    img: require("@/assets/images/games/230_Speed-​​Showdown.jpg").default,
    url: game3Url + "?game_id=230",
    online: OnlineNumberGenerator(230),
  },
  232: {
    id: 232,
    name: "Scratch Cards",
    img: require("@/assets/images/games/232_zeus.jpg").default,
    url: game3Url + "?game_id=232",
    online: OnlineNumberGenerator(232),
    hide_demo: true,
  },
  234: {
    id: 234,
    name: "Sex Crash",
    img: require("@/assets/images/games/234_sex-crash_luka.jpg").default,
    url: game3Url + "?game_id=234",
    online: OnlineNumberGenerator(234),
    hide_demo: true,
  },
  235: {
    id: 235,
    name: "Gates Of Gatotkaca",
    img: require("@/assets/images/games/235_gates_of_gatotkaca_luka.jpg").default,
    url: game3Url + "?game_id=235",
    online: OnlineNumberGenerator(235),
    hide_demo: true,
  },
  236: {
    id: 236,
    name: "Football 777 Plus",
    online: OnlineNumberGenerator(236),
    jackpot: JackpotNumberGenerator(322, 1000000, 10000000),
    img: require("@/assets/images/games/236_football_plus.jpg").default,
    url: game3Url + "?game_id=236",
  },
};

const games_originals = [games[223], games[201], games[208], games[202], games[232], games[234], games[228], games[230], games[217], games[205]];
const games_originals_b = [games[223], games[201], games[208], games[204], games[232], games[234], games[228], games[230], games[217], games[205]];
const games_popular = [
  games[236],
  games[215],
  games[207],
  games[210],
  games[119],
  games[222],
  games[219],
  games[211],
  games[220],
  games[213],
];
const games_popular_b = [
  games[236],
  games[119],
  games[207],
  games[210],
  games[215],
  games[222],
  games[219],
  games[211],
  games[220],
  games[213],
];
const games_spin = [games[201], games[223], games[202], games[205], games[215], games[213], games[221], games[203]];
const games_slots = [
  games[204],
  games[236],
  games[207],
  games[208],
  games[209],
  games[216],
  games[217],
  games[218],
  games[118],
  games[119],
  games[124],
  games[219],
  games[220],
  games[232],
  games[230],
  games[235],
];
const games_football = [games[211], games[208], games[209], games[236], games[207], games[212]];
const games_table_games = [games[212], games[203], games[214], games[229], games[234]];
const games_instant_games = [games[206], games[222], games[224], games[225], games[227], games[228]];

const MarqueeGenerator = (count) => {
  // return [
  //   {
  //     phone: "",
  //     content:
  //       "Server maintenance on September 8th, 5:00-7:00 AM. Services will be interrupted. Apologies for the inconvenience.",
  //   },
  // ];
  let { langText } = React.useContext(LanguageContext);
  let gameKeys = Object.keys(games);
  let marqueeList = [];
  for (let i = 0; i < count; i++) {
    // let amount = (SinNumberGenerator(((NowTimestamp / 100000) % 100000) / 50000 / Math.PI, seed+i / 10) * 700 + 200).toFixed(0);
    let amount = (
      SinNumberGenerator(((NowTimestamp / 100000) % 100000) / 50000 / Math.PI, i) * (100000 - 10000) +
      10000
    ).toFixed(0);
    let phone = (
      SinNumberGenerator(((NowTimestamp / 100000) % 100000) / 50000 / Math.PI, i) * (99999 - 1000) +
      1000
    ).toFixed(0);
    if (phone.length < 5) {
      phone = `0${phone}`;
    }
    phone = `${phone.substring(0, 1)}****${phone.substring(2, 5)}`;

    let gameIndex = Math.floor(
      SinNumberGenerator(((NowTimestamp / 100000) % 100000) / 50000 / Math.PI, i) * (gameKeys.length - 1 - 0) + 0
    );
    let random = Math.random()
    let content = ""
    content = langText("home_tips_notify", { param1: phone, param2: amount, param3: games[gameKeys[gameIndex]].name });
    if (random > 0.5) {//显示的是提款
      let randomValue = Math.floor(Math.random() * 9000) + 1000
      content = langText("home_tips_notify_2", { param1: phone, param2: randomValue });
    }
    marqueeList.push({
      content: content
    });
  }
  return marqueeList;
};

const Home = () => {
  const containerRef = React.useRef(null);
  const pageScrolledRef = React.useRef(false);
  const { getPersist, setPersist } = React.useContext(PersistContext);
  const { rootState, setRootStateKey } = React.useContext(RootStateContext);
  const { getLanguage, langText, langImg } = React.useContext(LanguageContext);
  const history = useEnhancedHistory();
  const [downloadTipClosed, setDownloadTipClosed] = useState(true);
  const [homeScreenTipClosed, sethomeScreenTipClosed] = useState(true);
  const [whatsApp, setWhatsApp] = useState("85253053474");
  //跑马灯
  const [marquee, setMarquee] = useState(MarqueeGenerator(3));
  const [bannerAds, setBannerAds] = useState(BannerAds);

  //每次到首页时重置登录页面状态
  setPersist("isLogin", false);
  useEffect(() => {
    if (getPersist("login_back_url")) {
      setPersist("login_back_url", null);
    }
  }, []);
  useEffect(() => {
    if (getPersist("dataLoaded")) {
      let channel = getPersist("channel");
      if (["yfb4", "yfb3yd1"].indexOf(channel) > -1) {
        setPersist("downloadTipClosed", true);
        setDownloadTipClosed(true);
      }
      setDownloadTipClosed(getPersist("downloadTipClosed"));
    }
  }, [getPersist("dataLoaded"), getPersist("channel"), getPersist("downloadTipClosed")]);
  useEffect(() => {
    let bgSettings = getPersist("bgSettings");
    let closeMarqueeTimer = null;
    if (bgSettings && bgSettings.marquee && bgSettings.marquee.info) {
      if (bgSettings.marquee.startTime < Date.now() / 1000 && bgSettings.marquee.endTime > Date.now() / 1000) {
        setMarquee([{ content: bgSettings.marquee.info }]);
        if (closeMarqueeTimer) {
          clearTimeout(closeMarqueeTimer);
        }
        closeMarqueeTimer = setTimeout(() => {
          setMarquee(MarqueeGenerator(3));
        }, bgSettings.marquee.endTime * 1000 - Date.now());
      }
    }
    if (
      bgSettings &&
      bgSettings.settings &&
      bgSettings.settings.client_config &&
      bgSettings.settings.client_config.whatsapp
    ) {
      setWhatsApp(bgSettings.settings.client_config.whatsapp);
    }
    return () => {
      if (closeMarqueeTimer) {
        clearTimeout(closeMarqueeTimer);
        closeMarqueeTimer = null;
      }
    };
  }, [getPersist("bgSettings")]);
  // document.write(navigator.userAgent)
  const homeTabMarginTop = downloadTipClosed ? "3.8rem" : "7rem";
  const topAreaHeight = downloadTipClosed ? "9.5rem" : "12.6rem"; // 12 8 3.5
  const [showingLayerGame, setShowPlayGameLayer] = React.useState(null);
  const onWillPlayGame = (game) => {
    SendEvent("game_entrance_click", { game_id: game.id });
    setShowPlayGameLayer(game);
  };
  const userInfo = getPersist("user_info");

  console.log("userInfo", userInfo);
  /**
   * 首页弹窗规则
   * 1. 如果用户没有登录，弹出首充，但是按钮显示注册
   * 2. 如果用户登录了，但是没有首充，弹出首充，按钮显示存款
   * 3. 如果用户登录了，首充了，弹出无限代活动，无限代活动每天只弹一次
   *
   *
   */
  //首冲广告弹框
  const [depositNowDiaLogVisible, setDepositNowDiaLogVisible] = useState(0);
  // FreeCash广告弹框
  const [freecashDialogVisible, setFreecashDialogVisible] = useState(false);
  // 用户优惠充值弹窗
  const [depositActivityDiaLogVisible, setDepositActivityDiaLogVisible] = useState(0);
  const [depositActivityData, setDepositActivityData] = useState({});
  const [depositActivityCountDown, setDepositActivityCountDown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  //限时活动只有充值后才不弹出
  const [limitDiscountsDiaLogVisible, setLimitDiscountsDiaLogVisible] = useState(false);

  //点击DEPOSIT NOW按钮事件
  const onDepositNowClick = () => {
    //隐藏首冲弹框
    setDepositNowDiaLogVisible(false);
    if (depositNowDiaLogVisible == 1) {
      setRootStateKey("depositPromotionOpenTime", 0);
      SendEvent("pupop_reister_ad_click", { signed_in: !!userInfo });
      //跳转到注册页面
      history.push(ChannelRemind(`/login?${getPersist("last_phone") ? "" : "reg=1"}`));
      return;
    }
    SendEvent("pupop_deposit_ad_click", { signed_in: !!userInfo });
    //跳转到充值页面
    history.push(ChannelRemind("./deposit?deposit_now=" + (NumericalConfig.firstRechargeAmount / 100).toFixed(0)));
  };

  //点击DEPOSIT NOW Activity按钮事件
  const onDepositActivityClick = () => {
    //隐藏首冲弹框
    setDepositActivityDiaLogVisible(false);
    if (depositActivityDiaLogVisible == 1) {
      //跳转到注册页面
      history.push(ChannelRemind(`/login?${getPersist("last_phone") ? "" : "reg=1"}`));
      return;
    }
    //跳转到充值页面
    history.push(ChannelRemind("./deposit?deposit_now=" + (NumericalConfig.limitDiscounts / 100).toFixed(0)));
  };

  //无限代活动弹框
  const [referFriendsDiaLogVisible, setReferFriendsDiaLogVisible] = useState(false);
  //点击REFER FRIENDS按钮事件
  const OnReferFriendsClick = () => {
    SendEvent("pupop_invite_ad_click", { signed_in: !!userInfo });
    //隐藏无限代活动弹框
    setReferFriendsDiaLogVisible(false);
    //跳转 要求好友活动界面
    history.push(ChannelRemind("./invite"));
  };

  //Get Coins弹框
  const [coinsDiaLogVisible, setCoinsDiaLogVisible] = useState(0);

  //是否显示免费转盘弹框
  const [inviteWheelCanvasDiaLogVisible, setInviteWheelCanvasDiaLogVisible] = useState(false);
  const [floatBall, setFloatBall] = useState(true);
  const [downloadFloatBall, setDownloadFloatBall] = useState(false);

  const deferredPrompt = useRef(null);

  const bindBeforeinstallprompt = (e) => {
    console.log("bindBeforeinstallprompt loaded", e);
    console.log("FromInstalled", FromInstalled);
    sethomeScreenTipClosed(FromInstalled);
    e.preventDefault();
    deferredPrompt.current = e;
  };

  //获取是否首冲
  useEffect(() => {
    SendEvent("home_loaded", {});
    if (!getPersist("user_info")) {
      //如果用户没有登录，弹出首充，但是按钮显示注册,每天弹一次
      let day = localStorage.getItem('depositNowDiaLog')
      if (new Date().getDay() != day) {
        //首冲广告弹框
        setDepositNowDiaLogVisible(1);
        setRootStateKey("depositPromotionOpenTime", Date.now());
        localStorage.setItem('depositNowDiaLog', new Date().getDay())
      }
      // 如果没有登录，先弹出活动弹窗
      if (getPersist("recall_act_open")) {
        setDepositActivityDiaLogVisible(1);
      }

      //如果用户没有登录，弹出免费转盘弹框
      setInviteWheelCanvasDiaLogVisible(true);

      //如果用户没登录，首充广告跳转到注册页面
      if (bannerAds.first_deposit) {
        bannerAds.first_deposit.link = ChannelRemind(`/login?${getPersist("last_phone") ? "" : "reg=1&"}`);
        setBannerAds(Object.assign({}, bannerAds));
      }

      //如果用户没有登录，不显示下载广告
      // bannerAds.install.hide = true;
    } else {
      //如果用户已经登录，首充广告跳转到充值页面
      if (bannerAds.first_deposit) {
        bannerAds.first_deposit.link = "/deposit?deposit_now=" + (NumericalConfig.firstRechargeAmount / 100).toFixed(0);
        setBannerAds(Object.assign({}, bannerAds));
      }



      //如果用户已经登录，恢复下载广告
      // bannerAds.install.hide = false;

      //获取充值级别相关数据
      getRechargeLevels();
      setFloatBall(true);
    }



    //监听添加到主屏幕是否可用
    if (window && !deferredPrompt.current) {
      console.log("bindBeforeinstallprompt listen");
      window.addEventListener("beforeinstallprompt", bindBeforeinstallprompt);
    }
    //判断要不要显示安装广告
    if (FromInstalled) {
      bannerAds.install.hide = true;
      setBannerAds(Object.assign({}, bannerAds));
    } else {
      setDownloadFloatBall(true);
    }
    return () => {
      if (window && deferredPrompt.current) {
        deferredPrompt.current = null;
        window.removeEventListener("beforeinstallprompt", bindBeforeinstallprompt);
      }
    };
  }, []);
  const getRechargeLevels = () => {
    //请求参数判断： 是否游客
    let data = {};
    if (userInfo) {
      data = { token: userInfo.token };
    }
    SendCMD("getRechargeLevels", data).then((res) => {
      if (!res.status) {
        console.log(res.errdesc);
      } else if (res.first_recharge_bonus) {
        if (Date.now() - rootState.depositPromotionOpenTime > 3600000) {
          //首冲广告弹框
          setDepositNowDiaLogVisible(2);
          setRootStateKey("depositPromotionOpenTime", Date.now());
        }
      } else {
        bannerAds.first_deposit = null;
        delete bannerAds.first_deposit;
        setBannerAds(Object.assign({}, bannerAds));

      }
      if (userInfo && getPersist("invitePromotionOpenDay") != new Date().getDay()) {
        //无限代活动弹框
        setReferFriendsDiaLogVisible(true);
        setPersist("invitePromotionOpenDay", new Date().getDay());
      }
      //限时活动只有充值后才不弹出
      setLimitDiscountsDiaLogVisible(res.recall_act_open)
      if (res.status && res.recall_act_open) {
        //充值活动弹框
        setDepositActivityDiaLogVisible(2);
        // 获取本地时间与服务器时间偏移值，通过偏移值计算本地活动结束时间
        let offsetTime = res.recall_act_now - Math.floor(Date.now() / 1000)
        let endTime = res.recall_act_end_time - offsetTime
        setDepositActivityData({
          endTime: endTime,
          client_show_time: res.client_show_time,
        })
      } else {
        bannerAds.activity_deposit = null;
        delete bannerAds.activity_deposit;
        setBannerAds(Object.assign({}, bannerAds));
      }
      if (getPersist("user_info")) {
        //如果今天没有弹过的话，自动弹出,由于会受其它活动的影响，所以写在最后
        if (getPersist("freecashPopupDay") != new Date().getDay()) {
          setFreecashDialogVisible(true);
        }

      }
    });
  };

  const GameLayer = ({ game }) => {
    if (!game) return null;
    let fullGameUrl = ChannelRemind(`/game?game_id=${game.id}&url=${encodeURI(game.url)}`);
    if (!userInfo) {
      fullGameUrl = ChannelRemind(`/login?${getPersist("last_phone") ? "" : "reg=1"}`);
    }

    const onFullGameClick = () => {
      if (!userInfo) {
        setPersist("login_back_url", fullGameUrl);
      }
      SendEvent("game_play_click", { game_id: game.id });
    };
    return (
      <div class={style.playContent}>
        <img src={game.img} alt="" />
        <div class={style.gameInfo}>
          <div class={style.gameName}>{game.name}</div>
          <div class={style.gameDesc}>
            {game.hide_demo
              ? null
              : "Demo: Money in the Demo account is not withdrawable, it is for practice purposes only!"}
          </div>
          <div class={style.gameBtns}>
            <MyNavLink
              to={ChannelRemind(`/game?game_id=${game.id}&demo=1&url=${encodeURI(game.url)}`)}
              onClick={() => SendEvent("game_demo_click", { game_id: game.id })}
              style={game.hide_demo ? { display: "none" } : {}}
            >
              <span class={style.gameBtnDemo}>Demo</span>
            </MyNavLink>
            <MyNavLink to={fullGameUrl} onClick={onFullGameClick}>
              <span class={style.gameBtnMode}>Play Now</span>
            </MyNavLink>
          </div>
        </div>
      </div>
    );
  };
  const OnTabChange = (index) => {
    console.log("OnTabChange", index);
    switch (index) {
      case 1:
        setCoinsDiaLogVisible(true);
        break;
      // case 2:
      //   if (!slotsRef.current || !containerRef.current) return;
      //   containerRef.current.scrollTop = slotsRef.current.offsetTop - 40 - (downloadTipClosed ? 0 : 50);
      //   break;
      // case 3:
      //   if (!footballRef.current || !containerRef.current) return;
      //   containerRef.current.scrollTop = footballRef.current.offsetTop - 40 - (downloadTipClosed ? 0 : 50);
      //   break;
    }
  };

  const AddToHomeScreen = () => {
    SendEvent("add_home_screen", {});
    if (!deferredPrompt.current) {
      sethomeScreenTipClosed(true);
      console.log("deferredPrompt.current is null");
      SendEvent("add_home_screen_result", { result: "error" });
      return;
    }
    deferredPrompt.current.prompt();
    deferredPrompt.current.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        sethomeScreenTipClosed(true);
        SendEvent("add_home_screen_result", { result: "accepted" });
        console.log("User accepted the install prompt");
      } else {
        SendEvent("add_home_screen_result", { result: "rejected" });
        console.log("User dismissed the install prompt");
      }
    });
  };

  const [nowShowingIndex, setNowShowingIndex] = useState(0);

  const OnGameTabChange = (index) => {
    console.log("OnGameTabChange", index);
    setNowShowingIndex(index);
  };

  const onMainGameClick = () => {
    SendEvent("crash_dynamic_ad_click", { signed_in: !!userInfo });
    if (getPersist("user_info")) {
      history.push(ChannelRemind(`/game?game_id=${games[210].id}&url=${encodeURI(games[210].url)}`));
    } else {
      history.push(ChannelRemind(`/game?game_id=${games[210].id}&demo=1&url=${encodeURI(games[210].url)}`));
    }
  };
  const getHomeGameContainer = (index) => {
    switch (index) {
      case 0:
        return (
          <>
            <HomeGameContainer
              icon={require("@/assets/images/home/class_icon/icon_originsals2.png").default}
              name="Original"
              games={getPersist("abtest_tag") == "t8:g2" ? games_originals_b : games_originals}
              onGameClick={onWillPlayGame}
            />
            <HomeGameContainer
              icon={require("@/assets/images/home/class_icon/icon_popular2.png").default}
              name="Popular"
              games={getPersist("abtest_tag") == "t8:g2" ? games_popular_b : games_popular}
              onGameClick={onWillPlayGame}
            />
            <HomeGameContainer
              icon={require("@/assets/images/home/class_icon/icon_spin2.png").default}
              name="Spin"
              games={games_spin}
              onGameClick={onWillPlayGame}
            />
            <HomeGameContainer
              icon={require("@/assets/images/home/class_icon/icon_slots2.png").default}
              name="Slots"
              games={games_slots}
              onGameClick={onWillPlayGame}
            />
            <HomeGameContainer
              icon={require("@/assets/images/home/class_icon/icon_football2.png").default}
              name="Football"
              games={games_football}
              onGameClick={onWillPlayGame}
            />
            <HomeGameContainer
              icon={require("@/assets/images/home/class_icon/icon_tableGames2.png").default}
              name="Table Games"
              games={games_table_games}
              onGameClick={onWillPlayGame}
            />
            <HomeGameContainer
              icon={require("@/assets/images/home/class_icon/icon_instantGames2.png").default}
              name="Instant Games"
              games={games_instant_games}
              onGameClick={onWillPlayGame}
            />
          </>
        );
      case 1:
        return (
          <HomeGameContainer
            icon={require("@/assets/images/home/class_icon/icon_popular2.png").default}
            name="Popular"
            games={games_popular}
            onGameClick={onWillPlayGame}
          />
        );
      case 2:
        return (
          <HomeGameContainer
            icon={require("@/assets/images/home/class_icon/icon_spin2.png").default}
            name="Spin"
            games={games_spin}
            onGameClick={onWillPlayGame}
          />
        );
      case 3:
        return (
          <HomeGameContainer
            icon={require("@/assets/images/home/class_icon/icon_slots2.png").default}
            name="Slots"
            games={games_slots}
            onGameClick={onWillPlayGame}
          />
        );
      case 4:
        return (
          <HomeGameContainer
            icon={require("@/assets/images/home/class_icon/icon_football2.png").default}
            name="Football"
            games={games_football}
            onGameClick={onWillPlayGame}
          />
        );
      case 5:
        return (
          <HomeGameContainer
            icon={require("@/assets/images/home/class_icon/icon_tableGames2.png").default}
            name="Table Games"
            games={games_table_games}
            onGameClick={onWillPlayGame}
          />
        );
      case 6:
        return (
          <HomeGameContainer
            icon={require("@/assets/images/home/class_icon/icon_instantGames2.png").default}
            name="Instant Games"
            games={games_instant_games}
            onGameClick={onWillPlayGame}
          />
        );
    }
  };
  return (
    <div
      class={style.page_container}
      ref={containerRef}
      onScroll={() => {
        if (!pageScrolledRef.current) {
          pageScrolledRef.current = true;
          SendEvent("home_page_scrolled", {});
        }
      }}
    >
      <HomeHeader />
      <div class={style.main}>
        <div
          class={style.top}
          style={{ height: topAreaHeight, borderBottomLeftRadius: "1rem", borderBottomRightRadius: "1rem" }}
        >
          <div style={{ marginTop: homeTabMarginTop, paddingLeft: "1rem", paddingRight: "1rem" }}>
            <HomeTabNav2 activeIndex={0} list={HomeTabList} onTabChange={OnTabChange} />
          </div>
        </div>
        <Slides list={Object.values(bannerAds)} />
        <div class={style.marquee}>
          <img src={require("@/assets/icons/notification.svg").default} style={{ width: "1.25rem" }} />
          <Swiper autoplay={7000} loop touchable={false} indicator={false} vertical style={{ height: "1.4rem" }}>
            {marquee.map((value, index) => (
              <Swiper.Item key={index}>
                <NoticeBar
                  text={` ${value.content}`}
                  background="rgba(0,0,0,0)"
                  color="#f1bf3f"
                  style={{
                    marginTop: "0.1rem",
                    "--rv-notice-bar-height": "20px",
                    "--rv-notice-bar-line-height": "14px",
                    color: "#E6DFAE",
                    fontWeight: "700",
                    fontSize: "0.75rem",
                  }}
                />
              </Swiper.Item>
            ))}
          </Swiper>
        </div>
        {/*= <FootballResult list={FootballResultList} /> */}
        {/* 如果是第二个AB实验的第二组 */}
        {/* {getPersist("abtest_tag") == "t5:g2" ? null : (
          <div class={style.main_game} onClick={onMainGameClick}>
            <CrashGameArea />
          </div>
        )} */}

        <div class={style.home_game_tab_nav + " home_game_tab"}>
          <HomeGameTabNav activeIndex={0} onTabChange={OnGameTabChange} />
        </div>
        {getHomeGameContainer(nowShowingIndex)}

        <div class={style.footer}>
          <div class={style.footer_country_info}>
            <div class={style.footer_country_icon}>
              <div class={style.footer_country_icon1}>
                <img src={require("@/assets/icon.png").default} />
              </div>
              <div class={style.footer_country_icon2}>
                <img src={require("@/assets/images/header/fz_char_logo_white.png").default} />
              </div>
            </div>
            <div class={style.footer_country_intro}>SAKA SAKA! Good luck, get rich tonight!</div>
            <div class={style.footer_country_select}>
              <Countryshow from="Home" />
            </div>
          </div>
          <div class={style.footer_link}>
            <div class={style.link}>
              <MyNavLink to="/about" style={{ border: "0px", paddingRight: "0.6rem", paddingLeft: "0.6rem" }}>
                <div class={style.link_span}>
                  <span>ABOUT US</span>
                </div>
              </MyNavLink>
              <MyNavLink to="/contact">
                <div class={`${style.link_span} ${style.link_us}`}>
                  <span>CONTACT US</span>
                </div>
              </MyNavLink>
              <MyNavLink to="/help">
                <div class={style.link_span}>
                  <span>HOW TO PLAY</span>
                </div>
              </MyNavLink>
            </div>
            <div class={style.home_service}>
              <div class={style.home_service_img}>
                <img src={require("@/assets/images/home/kftb_1.png").default} />
              </div>
              <div class={style.home_service_intro}>
                WhatsApp: {whatsApp}
                <CopyToClipboard
                  text={whatsApp}
                  onCopy={() => {
                    Toast.success({
                      message: "Copy Successfully",
                    });
                  }}
                >
                  <img
                    style={{ width: "1rem", height: "1rem", margin: "0 0 0 .5rem" }}
                    src={require("@/assets/icons/copy.png").default}
                  />
                </CopyToClipboard>
              </div>
            </div>
            <div class={style.share}>
              <div class={style.add_customer_service}>
                {langText("home_tips_1", { param1: 5 })}
              </div>
            </div>
            <div class={style.share}>
              <div class={style.share_intro}>
                GameLuka will respond to all of your requests. Contact us using one of the methods listed below.
              </div>
              <div class={style.share_type}>
                <MyNavLink to={`https://wa.me/${whatsApp}`} target="_blank" rel="noreferrer">
                  <img src={require("@/assets/icons/share5.svg").default} style={{ width: "2.5rem" }} />
                </MyNavLink>
                <MyNavLink to="https://business.facebook.com/gameluka" target="_blank" rel="noreferrer">
                  <img src={require("@/assets/icons/share3.svg").default} style={{ width: "2.5rem" }} />
                </MyNavLink>
                <MyNavLink to="https://twitter.com/gameluka" target="_blank" rel="noreferrer">
                  <img src={require("@/assets/icons/share2.svg").default} style={{ width: "2.5rem" }} />
                </MyNavLink>
                <MyNavLink to="https://www.instagram.com/gameluka" target="_blank" rel="noreferrer">
                  <img src={require("@/assets/images/home/share1.png").default} style={{ width: "2.5rem" }} />
                </MyNavLink>
              </div>
            </div>
          </div>
          <div class={style.terms}>
            <div class={style.terms_con}>
              <MyNavLink to="/termcond" style={{ textDecoration: "underline" }}>
                <span> Terms & Conditions</span>
              </MyNavLink>
            </div>
            <div class={style.terms_pri_res}>
              <MyNavLink to="/privacy" style={{ textDecoration: "underline" }}>
                <span>Privacy Policy</span>
              </MyNavLink>
              <MyNavLink to="/respgame" style={{ textDecoration: "underline" }}>
                {" "}
                <span>Responsible Gaming</span>
              </MyNavLink>
            </div>
          </div>

          <div class={style.licence}>
            <div class={style.licence_title}>
              <div class={style.licence_circle} />
              <div>LICENCE</div>
              <div class={style.licence_circle} />
            </div>
            <div class={style.licence_intro}>
              SAKA GAME LIMITED is licensed by: BCLB under the Betting. Lotteries and Gaming Act. Laws of Kenva under
              license No : 0000356 Note: Gaming can be addictive ! Not for persons under 18 years
            </div>
          </div>
          <div class={style.partner_email}>
            {/* <MyNavLink to={"mailto:partners@" + LocationInfo().domain}>
              <span>Partners</span>
              <span>partners@{LocationInfo().domain}</span>
            </MyNavLink> */}
            <MyNavLink to={"mailto:partners@" + LocationInfo().domain}>
              <span>cooperate</span>
              <span>telegram:https://t.me/gameluka5</span>
            </MyNavLink>
          </div>
        </div>
      </div>
      <Popup
        visible={showingLayerGame != null}
        style={{ backgroundColor: "#1c1c1c" }}
        position="bottom"
        closeOnClickOverlay={true}
        closeable={true}
        onClose={() => setShowPlayGameLayer(null)}
        destroyOnClose={true}
        transition="rv-fade"
      >
        <GameLayer game={showingLayerGame} />
      </Popup>
      <Popup
        visible={!homeScreenTipClosed}
        style={{ backgroundColor: "#1c1c1c" }}
        position="bottom"
        closeOnClickOverlay={true}
        closeable={false}
        onClose={() => sethomeScreenTipClosed(true)}
        destroyOnClose={true}
        transition="rv-fade"
      >
        <div class={style.addFavContent}>
          <div class={style.addFavTitle}>
            <img src={require("@/assets/app_icon.png").default} />
            <div style={{ flex: 1, color: "#ccc" }}>
              <p>Add GameLuka to your HomeScreen for a better experience.</p>
              <p>
                And get{" "}
                <span style={{ color: "orange" }}>
                  {NumericalConfig.addHomeScreenRewardFrom}~{NumericalConfig.addHomeScreenRewardTo}{" "}
                  {LocalConfig.currencyCode} bonus
                </span>
                .
              </p>
            </div>
          </div>
          <div class={style.addFavButton}>
            <div class={style.addFavCancelButton} onClick={() => sethomeScreenTipClosed(true)}>
              Cancel
            </div>
            <div class={style.addFavOkButton} onClick={AddToHomeScreen}>
              OK
            </div>
          </div>
        </div>
      </Popup>
      <Dialog
        closeable={true}
        width={"95%"}
        closeOnClickOverlay={true}
        // closeIcon={<Close />}
        visible={depositNowDiaLogVisible != 0 && !depositActivityDiaLogVisible && !limitDiscountsDiaLogVisible}
        showCancelButton={false}
        className={style.depositNowDialog}
        showConfirmButton={false}
        onClose={() => {
          if (depositNowDiaLogVisible == 1) {
            SendEvent("pupop_reister_ad_close", { signed_in: !!userInfo });
          } else {
            SendEvent("pupop_deposit_ad_close", { signed_in: !!userInfo });
          }
          setDepositNowDiaLogVisible(false);
        }}
      >
        <div class={style.firstDepositDialog}>
          <div class={style.firstDepositDialogBtn} onClick={onDepositNowClick}>
            <div class={style.firstDepositDialogBtnText}>
              <span>
                {depositNowDiaLogVisible == 1 ? (
                  <img
                    style={{ width: "9.3rem", height: "1.7rem" }}
                    src={require("@/assets/images/home/anniu1.png").default}
                  />
                ) : (
                  <img
                    style={{ width: "9.3rem", height: "1.7rem" }}
                    src={require("@/assets/images/home/anniu2.png").default}
                  />
                )}
              </span>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        closeable={true}
        width={"95%"}
        closeOnClickOverlay={true}
        // closeIcon={<Close />}
        visible={limitDiscountsDiaLogVisible}
        showCancelButton={false}
        className={style.depositNowDialog_other}
        showConfirmButton={false}
        onClose={() => {
          setLimitDiscountsDiaLogVisible(false);
          setDepositActivityDiaLogVisible(false);
        }}
      >
        <div style={{
          textAlign: "centen",
          height: "30rem",
          background: `url("../../assets/images/home/popup_deposit_activity_bg.png") no-repeat 100%`,
          backgroundSize: "100%",
          backgroundPosition: "center",
          marginTop: "-2rem",
        }}>
          <div
            className={
              style.limitDiscountsDiaLogBtn
            }
            onClick={onDepositActivityClick}
          >
            <div style={{
              marginTop: "-2.2rem",
              marginLeft: "8.5rem",
            }}>
              <span>
                <div style={{
                  width: "100%",
                  height: "0",
                }}>
                  <div style={{
                    position: "absolute",
                    transform: "translate(-2.5rem, -7.1rem)",
                    marginTop: "5.7rem",
                    fontSize: "0.73rem",
                    fontWeight: "bold",
                    color: "rgb(255, 227, 208)"
                  }}>
                    Event Time: {depositActivityData.client_show_time || getPersist("client_show_time")}
                  </div>
                </div>
                <div style={{
                  display: "grid",
                  placeItems: "center",
                  width: "9rem",
                  height: "2.7rem",
                  marginLeft: "-1rem",
                  marginTop: "29rem",
                  background: `url("../../assets/images/home/popup_deposit_activity_btn.png") no-repeat 100%`,
                  backgroundSize: "100%"
                }}>
                  <span style={{ fontWeight: "bolder", paddingBottom: "0.4rem", color: "rgb(255,255,255)" }} >{langText("home_btn_1")}</span>
                </div>
              </span>
            </div>
          </div>
        </div>
      </Dialog>

      <GetCoins coinsDiaLogVisible={coinsDiaLogVisible} setCoinsDiaLogVisible={setCoinsDiaLogVisible} />

      {/* <HomeInviteWheelCanvasDialog
        setFloatBall={setFloatBall}
        inviteWheelCanvasDiaLogVisible={inviteWheelCanvasDiaLogVisible}
        setInviteWheelCanvasDiaLogVisible={setInviteWheelCanvasDiaLogVisible}
      /> */}

      <HomeInviteWheelFloatBall floatBall={floatBall} />
      <DownloadFloatBall floatBall={downloadFloatBall} onClose={() => setDownloadFloatBall(false)} />
      <Dialog
        closeable={true}
        width={"95%"}
        closeOnClickOverlay={true}
        visible={referFriendsDiaLogVisible && !limitDiscountsDiaLogVisible}
        showCancelButton={false}
        className={style.depositNowDialog} // 弹框背景色
        showConfirmButton={false}
        onClose={() => {
          SendEvent("pupop_invite_ad_close", { signed_in: !!userInfo });
          setReferFriendsDiaLogVisible(false);
        }}
      >
        <div class={style.referFriendDialog}>
          <img style={{ width: "100%", height: "auto", maxHeight: "35rem" }} src={langImg("ing_2_1")} />
          <img
            style={{ width: "38%", height: "2.68rem", marginTop: "-4rem", marginLeft: "52%" }}
            src={require("@/assets/images/home/ing_3_1.png").default}
            onClick={OnReferFriendsClick}
          />
        </div>
      </Dialog>
      <Dialog
        closeable={true}
        width={"100%"}
        closeOnClickOverlay={true}
        visible={freecashDialogVisible && !depositNowDiaLogVisible && !referFriendsDiaLogVisible && !limitDiscountsDiaLogVisible}
        showCancelButton={false}
        className={style.referFriendDialog} // 弹框背景色
        showConfirmButton={false}
        onClose={() => {
          setPersist("freecashOpenDay", new Date().getDay());
          setFreecashDialogVisible(false);
        }}
      >
        <img
          style={{ width: "100%", height: "auto" }}
          src={langImg(LocalConfig.freeCashPopup)}
          onClick={() => {
            setPersist("freecashOpenDay", new Date().getDay());
            history.push(ChannelRemind("./FreeCash"));
          }}
        />
      </Dialog>
    </div>
  );
};

export default Home;
